import { useSelector } from 'react-redux';
import { editVariantBufferByFileUpload } from '../constants/featureFlag';
import { useFeatureFlag } from './useFeatureFlag';
import { getAuthorizedUsersAndSuppliersForFeatureFlag } from '../utils/user-based-feature-flag';

export function useEditVariantBufferByFileUpload() {
  const { currentUser, supplierId } = useSelector((state) => state.role);
  const userEmail = currentUser?.email;
  const featureFlagSupplierBasedValue = useFeatureFlag(editVariantBufferByFileUpload, JSON.stringify([]));

  return getAuthorizedUsersAndSuppliersForFeatureFlag({
    userEmail,
    supplierId,
    featureFlagSupplierBasedValue,
  });
}
